<div class="modal-body content width-600">
	<div class="layout-auto-1-auto">
		<h5 class="modal-header">{{getRessource('HeaderText')}}</h5>
		<div>
			<exg-select [(ngModel)]="typeIndex"
			            (ngModelChange)="changeType()"
			            [list]="types"
			            listdisplay="text"
			            [caption]="getRessource('Type')"
			            name="type"></exg-select>

			<div class="grid-1-auto">
				<exg-input [(ngModel)]="date"
				           [caption]="getRessource('Date')"
				           name="date"
				           type="date" [isEpoch]="true"></exg-input>
			<span *ngIf="!data.position" [tooltip]="getRessource('KeepValue')" flow="left">
				<i class="search-filter-action fa-duotone"
				   [class.fa-lock]="dateLocked"
				   [class.fa-lock-open]="!dateLocked"
				   (click)="dateLocked = !dateLocked"></i>
			</span>
			</div>

			<exg-input *ngIf="isExpense()"
			           [(ngModel)]="proof"
			           [caption]="getRessource('Proof')"
			           name="proof"></exg-input>

			<div class="grid-1-auto" *ngIf="!isExpense()">
				<exg-select [required]="true"
				            [(ngModel)]="provIndex"
				            (ngModelChange)="changeProv()"
				            [list]="provListData"
				            listdisplay="text"
				            [caption]="getRessource('Provider')"
				            name="prov"></exg-select>
			<span *ngIf="!data.position" [tooltip]="getRessource('KeepValue')" flow="left">
				<i class="search-filter-action fa-duotone"
				   [class.fa-lock]="provLocked"
				   [class.fa-lock-open]="!provLocked"
				   (click)="provLocked = !provLocked"></i>
			</span>
			</div>

			<div class="grid-1-auto">
				<exg-select *ngIf="hasDescList()"
				            [required]="true"
				            [(ngModel)]="descIndex"
				            (ngModelChange)="changeDesc()"
				            [list]="descListData"
				            listdisplay="text"
				            [caption]="getRessource('Description')"
				            name="descSelect"></exg-select>

				<exg-input *ngIf="!hasDescList()"
				           [(ngModel)]="desc"
				           [required]="true"
				           [maxlength]="250"
				           [caption]="getRessource('Description')"
				           name="desc"></exg-input>
			<span *ngIf="!data.position && hasDescList()" [tooltip]="getRessource('KeepValue')" flow="left">
				<i class="search-filter-action fa-duotone"
				   [class.fa-lock]="descLocked"
				   [class.fa-lock-open]="!descLocked"
				   (click)="descLocked = !descLocked"></i>
			</span>
			</div>

			<exg-input *ngIf="isExpense()" type="number"
			           [step]=1 inputmode="decimal"
			           [required]="true"
			           [(ngModel)]="netto"
			           (ngModelChange)="changeNetto()"
			           [caption]="getRessource('NetPrice')"
			           name="netto">
			</exg-input>

			<exg-input *ngIf="!isExpense() && !isHourUnit()" type="number"
			           [step]=1 inputmode="decimal"
			           [required]="true"
			           [(ngModel)]="amount"
			           (ngModelChange)="changeAmount($event)"
			           [caption]="getRessource('Amount')"
			           name="amount">
			</exg-input>

			<exg-input *ngIf="!isExpense() && isHourUnit()" type="number"
			           [step]=1 inputmode="numeric"
			           [min]="0"
			           [required]="true"
			           [(ngModel)]="amountHour"
			           (ngModelChange)="convertHourMinuteToAmount()"
			           [caption]="getRessource('Hours')"
			           name="amountHour">
			</exg-input>

			<exg-input *ngIf="!isExpense() && isHourUnit()" type="number"
			           [step]=1 inputmode="numeric"
			           [min]="0"
			           [required]="true"
			           [(ngModel)]="amountMinute"
			           (ngModelChange)="convertHourMinuteToAmount()"
			           [caption]="getRessource('Minutes')"
			           name="amountMinute">
			</exg-input>

			<div class="typo-container-s-s-q typo-small" *ngIf="!isExpense()">
				<span class="typo-small">{{getRessource('Unit')}}</span>
				<span>{{unit}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('SinglePrice')}}</span>
				<span>{{single | excCurrency: '€'}}</span>
				<q></q>
			</div>

			<exg-checkbox *ngIf="!isExpense()"
			              [(ngModel)]="internalPosition"
			              [caption]="getRessource('InternalPosition')"
			              name="internalPosition"></exg-checkbox>

			<exg-textarea [(ngModel)]="comment"
			              [maxlength]="4000"
			              [caption]="getRessource('CommentLabel')"
			              name="comment"></exg-textarea>

			<ng-container *ngIf="showInvoice()">
				<div class="app-section-header app-space-top">
					<h5>{{getRessource('InvoiceHeader')}}</h5>
				</div>

				<div class="typo-container-s-s-q typo-small">
					<span class="typo-small">{{getRessource('Unit')}}</span>
					<span>{{unit}}</span>
					<q></q>
					<span class="typo-small">{{getRessource('SinglePrice')}}</span>
					<span>{{invoicePrice | excCurrency: '€'}}</span>
					<q></q>
				</div>

				<exg-input *ngIf="!isHourUnit()" type="number"
				           [step]=1 inputmode="decimal"
				           [required]="true"
				           [(ngModel)]="invoiceAmount"
				           [caption]="getRessource('Amount')"
				           name="invoiceAmount">
				</exg-input>

				<exg-input *ngIf="isHourUnit()" type="number"
				           [step]=1 inputmode="numeric"
				           [min]="0"
				           [required]="true"
				           [(ngModel)]="amountInvoiceHour"
				           (ngModelChange)="convertInvoiceHourMinuteToAmount()"
				           [caption]="getRessource('Hours')"
				           name="amountInvoiceHour">
				</exg-input>

				<exg-input *ngIf="isHourUnit()" type="number"
				           [step]=1 inputmode="numeric"
				           [min]="0"
				           [required]="true"
				           [(ngModel)]="amountInvoiceMinute"
				           (ngModelChange)="convertInvoiceHourMinuteToAmount()"
				           [caption]="getRessource('Minutes')"
				           name="amountInvoiceMinute">
				</exg-input>

				<exg-input [(ngModel)]="invoiceComment"
				           [required]="isInvoiceAmountUpdated()"
				           [maxlength]="250"
				           [caption]="getRessource('InvoiceNote')"
				           name="invoiceComment"></exg-input>
			</ng-container>
		</div>

		<div class="spawn-modal-actions">
			<exg-checkbox *ngIf="!data.position"
			              [(ngModel)]="createMore"
			              [caption]="getRessource('AddAdditionalService')"
			              name="createMore"></exg-checkbox>
			<button class="md-btn"
			        [disabled]="!valid()"
			        (click)="save()">
				{{getGlobal('Save')}}
			</button>
			<button class="md-btn"
			        (click)="cancel()">
				{{getGlobal('Cancel')}}
			</button>
		</div>
	</div>
</div>
